import { createSlice } from "@reduxjs/toolkit";

const modelPanelSlice = createSlice({
  name: "modelPanel",
  initialState: "right", // "right", "bottom", "hidden-right", "hidden-bottom"
  reducers: {
    setModelPanel: (state, action) => {
      return action.payload;
    },
  },
});

export const { setModelPanel } = modelPanelSlice.actions;

export default modelPanelSlice.reducer;
